import { Component, ElementRef, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { LongtailService } from '@nx-superprep/backend/firebase'

@Component({
  selector: 'pop-ui-legal-unsubscribe',
  standalone: true,
  imports: [],
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss'],
  queries: {
    'form': new ViewChild('form'),
  }
})
export class UnsubscribeComponent {
  public form!: ElementRef
  submitted = false

  onSubmit() {
    this.submitted = true
    this.longtailService.removeAccount()
    this.router.navigate([''], { replaceUrl:true, skipLocationChange: true })
  }

  constructor(
    private router: Router,
    private longtailService: LongtailService
  ) {}
}
